module.exports = __webpack_public_path__ + "img/vc.e5184adf.png";